import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  }),
  tagTypes: ["auth"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/Login",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["auth"],
    })
  }),
});

export const { useLoginMutation} = authApi;
